import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

const BadgingBlacklistsList = ({
  onSelectBadgingBlacklist,
  badgingBlacklists,
}) => {
  const listRow = ListRow(onSelectBadgingBlacklist);

  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>VIN</Table.HeaderCell>
      <Table.HeaderCell>Seller ID</Table.HeaderCell>
      <Table.HeaderCell>Expiration Date</Table.HeaderCell>
      <Table.HeaderCell>Notes</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
      <Table.HeaderCell>Created At</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>Unit Badging Blacklist</Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={badgingBlacklists}
          headerRow={headerRow}
          size='tiny'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
        />
      </div>
    </div>
  );
};

BadgingBlacklistsList.propTypes = {
  onSelectBadgingBlacklist: PropTypes.func.isRequired,
  badgingBlacklists: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      vin: PropTypes.string,
      sellerNumber: PropTypes.string,
      expirationDate: PropTypes.string,
      notes: PropTypes.string,
      status: PropTypes.string,
      createdAt: PropTypes.string,
    })
  ),
};

BadgingBlacklistsList.defaultProps = {
  badgingBlacklists: [],
};

export default BadgingBlacklistsList;
